import Offcanvas from 'react-bootstrap/Offcanvas';
import { useContext, useEffect, useState } from 'react';
import './genericOffCanvas.css'
import bicepsSvg from '../../../assets/img/biceps-offCanva.svg';
import React from 'react'
import { Link } from 'react-router-dom';
import { AuthContext } from '../../../context/Authcontext'
import { getUserInfo } from './offCanvaController';
import { fetchTraining } from './offCanvaController';
import { GetExtraUrls } from './offCanvaController';
import { useToggle } from '../../../context/toggle/toggleBtn';



export const GenericOffCanvas = ({ UserLogo }) => {

  const {isActive , toggleBTN} = useToggle()


const {logout} = useContext(AuthContext)


const [memberStatus, setMerberStatus] = useState(null)
  const [urlService, setUrlService] = useState(null)
  const [extraUrls, setExtraUrls] = useState(null)

  //? sino existe en localStorage TPATrainingStatus setearlo
  const [refresh, setRefresh] = useState(false)

  const handleRefresh = () => {
    setRefresh(!refresh)
    //console.log('refresh')
  };

  useEffect(() => {

    //console.log('se ejecuta de nuevo')


    const setingUrl = async () => {

      const info = await getUserInfo()

      //console.log('infoSideMenu: ', info)

      if (info && info.data.subscriptions) {

        //console.log('info.data.subscriptions', info.data.subscriptions)
        localStorage.setItem('TPATrainingStatus', info.data.subscriptions.TPATraining)
        setMerberStatus(info.data.subscriptions.TPATraining)


      }
      
      const TPAmemberStatus = await fetchTraining()

      if (TPAmemberStatus) {
        //console.log('TPAmemberStatus', TPAmemberStatus.data.data.urlService)
        setUrlService(TPAmemberStatus.data.data.urlService)
        setMerberStatus(localStorage.getItem('TPATrainingStatus'))
      }

    }

    setingUrl()

    const getExtraUrl = async () => {
          const responseExtraUrls = await GetExtraUrls()
    
          setExtraUrls(responseExtraUrls);
        }
    
        getExtraUrl();

  }, [refresh])

    return (
        <>


            <Offcanvas
                show={isActive}
                // onHide={toggleBTN}
                placement="end"
                className="offCanvas-width"

            >
                <Offcanvas.Header
                //  closeButton
                 className='oc-header'
                 >
                    <UserLogo />
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <ul className="nav flex-column ul-offCanva">



                        <li className="li-menu">
                            <Link className="offCanva-link" to="./biblioteca" onClick={() => toggleBTN()}>
                                <span className="material-symbols-outlined">smart_display</span>
                                <p className="">TPA® Biblioteca</p>
                            </Link>
                        </li>

                        <li className="li-menu">
                            <Link className="offCanva-link" 
                            to={`${memberStatus === 'Approved' ? `${urlService}` : '/training'} `}
                            target={memberStatus === 'Approved' ? '_blank' : '_self'}
                
                            // state={memberStatus && { status: memberStatus } }
                
                            onClick={() => {
                                handleRefresh();
                                toggleBTN();
                              }}>

                                <img className="bicepsSvg" src={bicepsSvg} alt="" />
                                <p className="">TPA® Training</p>
                            </Link>
                        </li>

                        {/* Extra URLS traidas de RestAPI */}
                        {extraUrls && extraUrls.length > 0 ? extraUrls.map((l) => (

                          <li key={l.id} className="li-menu">
                            <Link
                                className="offCanva-link" 
                                to={ l.isInternal ? `/avisos/${l.id}` : l.url }
                                onClick={() => toggleBTN()}>
                                <span className="material-symbols-outlined">{l.icon}</span>
                                <p className="">{l.title}</p>
                            </Link>
                        </li>

                        )) : null }



                    </ul>

                    <div className="logOut-container" onClick={() => {logout()}}>
                        <span className="material-symbols-outlined offCanva-sesion">
                            exit_to_app
                        </span>
                        <p>Cerrar Sesión</p>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}


